import {
  notesDeleted,
  restoreNotesFromDbAsync,
  selectFirstNoteAsync,
  selectNoteEntities
} from "./notesSlice";
import { onFocusChange } from "../../../hooks/useFocusChanged";
import {
  activateLoadingLine,
  deactivateLoadingLine,
} from "../../layout/layoutSlice";
import isMobileView from "../../layout/isMobileView";
import config from "../../config/config";
import store from "../../../App/store";
import { useEffect } from "react";
import { syncNotesAsync } from "./actions";
import { initialiseSearchIndex } from "../searchDb";
import { createLogger } from "../../../utils/log";
import * as db from "../db";
const tenant = config.getTenant();

const log = createLogger("setupSync");
let synced = false;

export async function setup() {
  const dispatch = store.dispatch;
  const mobile = isMobileView();
  if (tenant) {
    if (synced) return;
    synced = true;

    onFocusChange(() => {
      dispatch(syncNotesAsync({ showSyncing: true }));
    });
    async function onFullSynced(ids) {
      log.info("ids loaded on full sync", ids);
      const notesToDelete = await db.deleteOrphanNotes(ids);
      dispatch(notesDeleted(notesToDelete));
    }
    try {
      dispatch(activateLoadingLine());
      await dispatch(restoreNotesFromDbAsync());
      if (!mobile) {
        await dispatch(selectFirstNoteAsync());
      }
      // Do a quick sync first to get updates then do a full sync in background on load.
      // Dont need to do a full sync if the first sync is a full sync

      const performedFullSync = await dispatch(
        syncNotesAsync({ showSyncing: true })
      );

      const notes = selectNoteEntities(store.getState());
      await initialiseSearchIndex(notes);

      !performedFullSync &&
        (await dispatch(
          syncNotesAsync({ fullSync: true, onSynced: onFullSynced })
        ));
    } finally {
      dispatch(deactivateLoadingLine());
    }
  }
}



export const SetupSync = () => {
  useEffect(() => {
    setup();
  }, []);
  return null;
};
